<script>
import Datatable from "@/router/layouts/table-datatable";
import Pagination from "@/router/layouts/table-pagination";
import ModalFormKompetensiProfesi from "./modal-form-kompetensi-profesi.vue";
import ModalImportProfesi from "../modal-import-profesi.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  components: {
    Datatable,
    Pagination,
    ModalImportProfesi,
    ModalFormKompetensiProfesi,
  },
  data() {
    let sortOrders = []; // select sortOrder
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "auto",
        label: "Kode Kompetensi",
        name: "kode_kompetensi",
      },
      {
        width: "auto",
        label: "Nama Kompetensi",
        name: "nama_kompetensi",
      },
      {
        width: "auto",
        label: "Level",
        name: "-",
      },
      {
        width: "auto",
        label: "Kode Profesi",
        name: "-",
      },
      {
        width: "auto",
        label: "Nama Profesi",
        name: "-",
      },
      {
        width: "150px",
        label: "Aksi",
        name: "-",
      },
    ];
    const menu = "Master Profesi";

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: menu,
      showModal: false,
      showModalImport: false,
      titleModal: "",
      typeModal: "add",
      loadingTable: false,
      columns: columns,
      sortKey: "updated_at",
      sortOrders: sortOrders,
      currentTablePage: "",
      tableData: [],
      tableFilter: {
        page: 1,
        draw: 0,
        per_page: 10,
        search: "",
        column: "updated_at",
        dir: "desc",
        kode_kompetensi: "",
        nama_kompetensi: "",
        kode_profesi: "",
        nama_profesi: "",
        level: "",
        filter_status: "ENABLE", // untuk filtering data
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  methods: {
    async getDataTable(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.loadingTable = true;
      this.tableData = [];
      const config = {
        method: "get",
        url: `${process.env.VUE_APP_BACKEND_URL_VERSION}master/kompetensi-profesi`,
        params: this.tableFilter,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
      await axios(config)
        .then((response) => {
          if (response.data.meta.code == 200) {
            this.tableData = response.data.data.data;
            this.currentTablePage = response.data.data.current_page;
            this.loadingTable = false;
            this.configPagination(response.data.data);
          } else {
            this.loadingTable = false;
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.data.meta.message,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.loadingTable = false;
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getDataTable(false);
    },
    importData() {
      this.showModalImport = true;
    },
    exportData() {
      let params = new URLSearchParams(this.tableFilter).toString();
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/kompetensi-profesi?" +
          params
      );
    },

    addData() {
      this.titleModal = "Tambah Data Profesi";
      this.typeModal = "add";
      this.dataModal = null;
      this.showModal = true;
    },
    editData(row) {
      this.titleModal = "Edit Data Profesi";
      this.typeModal = "edit";
      this.dataModal = row;
      this.showModal = true;
    },
    deleteData(row) {
      row.status = "DISABLE";
      Swal.fire({
        icon: "question",
        title: "Apakah Anda yakin menonaktifkan data ini ?",
        // text: "Data yang terhapus tidak dapat dipulihkan kembali!",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: '<i class="fas fa-spinner fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          axios({
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "master/kompetensi-profesi/" +
              row.idkompetensi,
            data: row,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          }).then((response) => {
            let response_data = response.data;
            if (response_data.meta.code != "200") {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response_data.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil dihapus.",
                timer: 2000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              }).then((result) => {
                if (result.dismiss) {
                  this.getDataTable();
                }
              });
            }
          });
        } else {
          Swal.close();
        }
      });
    },
  },
  mounted() {
    this.getDataTable();
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="d-flex justify-content-between">
          <div class="card-title">Master Profesi</div>
          <div class="d-flex gap-2">
            <button class="btn btn-success btn-sm" @click="exportData()">
              <i class="fa fa-file-excel me-1"></i> Export Excel
            </button>
            <button class="btn btn-info btn-sm" @click="importData()">
              <i class="fa fa-file-excel me-1"></i> Import Excel
            </button>
            <!-- <button class="btn btn-success btn-sm">
              <i class="fa fa-file-excel me-1"></i> Import Excel
            </button> -->
            <button class="btn btn-primary btn-sm" @click="addData()">
              <i class="fa fa-plus me-1"></i> Tambah Data
            </button>
          </div>
        </div>
        <div class="col-12">
          <hr />
          <div class="row">
            <div class="col-md-3 mt-2">
              <label for="filterKodeKompetensi">Kode Kompetensi</label>
              <input
                class="form-control"
                v-model="tableFilter.kode_kompetensi"
                placeholder="Filter Kode Kompetensi..."
                @input="filterData"
              />
            </div>
            <div class="col-md-3 mt-2">
              <label for="filterNamaKompetensi">Nama Kompetensi</label>
              <input
                class="form-control"
                v-model="tableFilter.nama_kompetensi"
                placeholder="Filter Nama Kompetensi..."
                @input="filterData"
              />
            </div>
            <div class="col-md-3 mt-2">
              <label for="filterKodeProfesi">Kode Profesi</label>
              <input
                class="form-control"
                v-model="tableFilter.kode_profesi"
                placeholder="Filter Kode Profesi..."
                @input="filterData"
              />
            </div>
            <div class="col-md-3 mt-2">
              <label for="filterNamaProfesi">Nama Profesi</label>
              <input
                class="form-control"
                v-model="tableFilter.nama_profesi"
                placeholder="Filter Nama Profesi..."
                @input="filterData"
              />
            </div>
          </div>
          <hr />
        </div>
        <datatable
          :columns="columns"
          :sortKey="sortKey"
          :sortOrders="sortOrders"
          @sort="sortBy"
        >
          <tbody>
            <tr v-if="loadingTable">
              <td colspan="99" class="text-center">
                <i class="fas fa-spinner fa-spin"></i> Loading...
              </td>
            </tr>
            <tr v-else-if="tableData.length == 0">
              <td colspan="99" class="text-center">Data tidak tersedia</td>
            </tr>
            <tr v-else v-for="(row, key) in tableData" :key="key">
              <td>
                <span v-if="key + 1 == 10"> {{ currentTablePage }}0. </span>
                <span v-else>
                  {{
                    currentTablePage - 1 != 0
                      ? currentTablePage - 1 + `${key + 1}`
                      : `${key + 1}`
                  }}.
                </span>
              </td>
              <td>{{ row.kode_kompetensi ?? "-" }}</td>
              <td>{{ row.nama_kompetensi ?? "-" }}</td>
              <td>{{ row.level_kompetensi?.nama_level ?? "-" }}</td>
              <td>{{ row.profesi?.kode_profesi ?? "-" }}</td>
              <td>{{ row.profesi?.nama_profesi ?? "-" }}</td>
              <td class="text-center">
                <div class="btn-group btn-group-sm">
                  <button class="btn btn-warning btn-sm" @click="editData(row)">
                    <i class="fa fa-edit"></i> Edit
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteData(row)"
                  >
                    <i class="fa fa-trash"></i> Disable
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </datatable>
      </div>
      <pagination :pagination="pagination" @to-page="toPage" />
    </div>
  </div>

  <b-modal v-model="showModal" :title="titleModal" hide-footer>
    <ModalFormKompetensiProfesi
      :typeTrans="typeModal"
      :dataKompetensiProfesi="dataModal"
      @submitForm="
        getDataTable();
        showModal = false;
      "
    ></ModalFormKompetensiProfesi>
  </b-modal>
  <b-modal v-model="showModalImport" title="Import Data Direktori Kompetensi" hide-footer>
    <ModalImportProfesi
      :module="'kompetensi-profesi'"
      @refreshTable="
        showModalImport = false;
        getDataTable();
      "
    />
  </b-modal>
</template>
